import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { AfterSales1ModalComponent } from '../after-sales1-modal/after-sales1-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-after-sales2-modal',
  templateUrl: './after-sales2-modal.component.html',
  styleUrls: ['./after-sales2-modal.component.scss'],
})
export class AfterSales2ModalComponent implements OnInit {
  flag = false;
  constructor(
    private api: MarketingApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modal: MatDialog,
    private modalRef: MatDialogRef<AfterSales1ModalComponent>,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.findArticlePlatform();
  }

  loading = false;
  page = 1;
  total = 0;
  articles: any;
  async findArticlePlatform() {
    try {
      this.loading = true;
      this.articles = [];
      const r = await this.api.findArticlePlatform(
        this.data.bus.platform.id,
        'aftersale',
        this.page,
        4
      );
      this.articles = r.data.list;
      this.total = r.data.total;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  changePage() {
    if (this.page * 4 < this.total) {
      this.page = this.page + 1;
    } else {
      this.page = 1;
    }
    this.findArticlePlatform();
  }

  openAfterSales1Modal() {
    this.modalRef.close();
    this.modal.open(AfterSales1ModalComponent, {
      width: '612px',
    });
  }

  openWorkorder() {
    this.router.navigate(['/user/profile/form/create'], {
      queryParams: { id: this.data.id },
    });
  }
}
